<!-- src/app/app.component.html -->
<petals-canvas></petals-canvas>

<section class="container">
  <article class="card invitation">
    <!-- pílula “1 aninho” centralizada -->
    <div class="badge-wrap">
      <div class="badge event-badge" role="status" aria-label="1 aninho">
        <span class="dot" aria-hidden="true">🌸</span>
        <span>1 aninho</span>
      </div>
    </div>

    <h1 class="title">Laura faz aniversário!</h1>
    <p class="subtitle">Um ano de amor e descobertas</p>

    <countdown [targetISO]="env.eventDateISO"></countdown>

    <div class="media">
      <div class="ratio">
        <carousel-swiper [images]="photosSafe" [autoplayMs]="3500"></carousel-swiper>
      </div>
    </div>

    <section class="info">
      <div class="row">
        <div class="ico" aria-hidden="true">🗓️</div>
        <div class="col">
          <div class="label">Quando</div>
          <div class="chips">
            <span class="chip">{{ dateStr }}</span>
            <span class="chip">{{ timeStr }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="ico" aria-hidden="true">📍</div>
        <div class="col">
          <div class="label">Local</div>
          <div class="address">
            <span class="addr">
              {{ addressMain }}<span *ngIf="cep">, {{ cep }}</span>
            </span>
            <span *ngIf="venue" class="venue-pill">{{ venue }}</span>
          </div>
        </div>
        <button class="icon-button" aria-label="Mais informações" (click)="openComun($event)">
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
        </button>
      </div>
    </section>

    <section class="actions">
      <a class="btn" [href]="mapsUrl" target="_blank" rel="noopener">Abrir no mapa</a>
      <a class="btn" [href]="icsUrl" download="Laura-1Aninho-19-12-2025.ics">Salvar na agenda</a>

      <!-- abre modal de presentes -->
      <a class="btn" href="#" (click)="openGifts($event)">Sugestão de presentes</a>

      <!-- abre modal de RSVP -->
      <a class="btn btn--primary" href="#" (click)="openRsvp($event)">Confirmar presença</a>

      <!-- <a class="btn" href="#" (click)="openConfir($event)">Confirmação</a>

      <a class="btn" href="#" (click)="openComun($event)">Comunicado</a> -->
    </section>

    <footer class="footnote">
      Sua presença vai deixar tudo ainda mais especial ✨
    </footer>
  </article>
</section>

<!-- Modal: Sugestão de presentes -->
<div class="modal-backdrop" *ngIf="giftsOpen" (click)="closeGifts()"></div>
<div class="modal " *ngIf="giftsOpen" role="dialog" aria-modal="true" aria-labelledby="giftTitle">
  <div class="modal__content" (click)="$event.stopPropagation()">
    <h2 class="title" id="giftTitle">🍒 A cereja do bolo!</h2>
    <p>Nossa cerejinha está crescendo rápido e deixando tudo mais doce! 🌸💕</p>
    <p>
      Se quiser presentear com algum brinquedo, sugerimos comprar online e enviar direto para o nosso endereço —
      será recebido com muito amor! ✈<br /><br />
      <strong class="copyable" (click)="copyAddress()" title="Clique para copiar">
        Rua Treze de Maio, 300 – São Luiz, Antônio Prado/RS | 95250-000
      </strong>
    </p>
    <p>Mas caso queira presentear com roupinhas ou outros itens, receberemos no local com todo amor! ❤️</p>
    <p><strong>Sugestões:</strong></p>
    <ul class="sugestoes">
      <li>🍒 <strong>Roupinhas:</strong> 12–18 meses</li>
      <li>🍒 <strong>Calçados:</strong> 19–22</li>
    </ul>
    <p>Brinquedos são todos <strong>Bem-vindos!</strong> ❤️</p>
    <div class="modal__actions">
      <button type="button" class="btn btn--primary" (click)="closeGifts()">OK</button>
    </div>
  </div>
</div>

<!-- Modal: RSVP (form sem acompanhante) -->
<div class="modal-backdrop" *ngIf="rsvpOpen" (click)="closeRsvp()"></div>
<div class="modal" *ngIf="rsvpOpen" role="dialog" aria-modal="true" aria-labelledby="rsvpTitle">
  <div class="modal__content" (click)="$event.stopPropagation()">
    <h2 class="title" id="rsvpTitle">Confirmar Presença</h2>
    <br />
    <br />
    <form class="modal__body" [formGroup]="form" (ngSubmit)="submitRsvp()">
      <!-- Nome -->
      <label class="form-row">
        <span><strong>Nome Completo *</strong></span>
        <input type="text" formControlName="name" placeholder="Seu nome" autocomplete="name" />
        <small class="err" *ngIf="form.get('name')?.touched && form.get('name')?.invalid">
          Informe seu nome.
        </small>
      </label>

      <!-- Crianças -->
      <div class="form-row-switch">
        <!-- O texto da label -->
        <span class="switch-label"><strong>Levará crianças?</strong></span>

        <!-- O componente do switch -->
        <label class="switch">
          <input type="checkbox" formControlName="hasChildren" />
          <span class="slider"></span>
        </label>
      </div>
      <!-- <label class="form-row switch">
        <input class="form-check-input" type="checkbox" formControlName="hasChildren" />
        <span><strong>Levará crianças?</strong></span>
      </label> -->

      <div class="kids" *ngIf="form.get('hasChildren')?.value">
        <div class="kid-row" *ngFor="let kid of children.controls; let i = index" [formGroup]="kid">
          <div class="kid-fields">
            <input type="text" formControlName="name" placeholder="Nome da criança" />
            <input type="number" min="0" max="18" step="1" formControlName="age" placeholder="Idade" />
          </div>
          <button type="button" class="btn small" (click)="removeChild(i)" aria-label="Remover criança">Remover</button>
          <small class="err" *ngIf="kid.get('name')?.touched && kid.get('name')?.invalid">Nome da criança é obrigatório.</small>
          <small class="err" *ngIf="kid.get('age')?.touched && kid.get('age')?.invalid">Idade da criança é obrigatória e deve ser um número.</small>
        </div>
        <button type="button" class="btn" (click)="addChild()">+ Adicionar criança</button>
        <small class="err" *ngIf="form.get('hasChildren')?.value && children.length === 0 && form.touched">
          Se você trará crianças, adicione pelo menos uma.
        </small>
      </div>

      <!-- status -->
      <div class="status" *ngIf="isSubmitting">Enviando…</div>
      <div class="status ok" *ngIf="submitOk">Presença registrada. Obrigado! 🎉</div>
      <div class="status err" *ngIf="submitError">Falha ao enviar. Tente novamente.</div>



      <div class="modal__actions">
        <button type="button" class="btn" (click)="closeRsvp()" [disabled]="isSubmitting">Cancelar</button>
        <button type="submit" class="btn btn--primary" [disabled]="form.invalid || isSubmitting">Confirmar</button>
      </div>
    </form>
  </div>
</div>

<!-- Modal: Confirmação -->
<div class="modal-backdrop" *ngIf="ConfirOpen" (click)="closeConfir()"></div>
<div class="modal" *ngIf="ConfirOpen" role="dialog" aria-modal="true" aria-labelledby="confirTitle">
  <div class="modal__content" (click)="$event.stopPropagation()">
    <h2 class="title" id="confirTitle">🎉 Presença Confirmada!</h2>
    <p>Estamos contando os dias para celebrar junto com as pessoas que ela mais ama, e você é uma delas. Saber que você
      vem deixou nosso coração em festa!</p>
    <p>Obrigado por aceitar nosso convite e por vir compartilhar essa alegria com a gente.</p>
    <p><strong>Sua presença é o melhor presente!</strong></p>
    <br>
    <p class="footnote">A contagem regressiva para a diversão começou! ✨</p>
    <div class="modal__actions">
      <button type="button" class="btn btn--primary" (click)="closeConfir()">OK</button>
    </div>
  </div>
</div>


<!-- Modal: Comunicado -->

<!--
  Melhoria: Adicionado keydown.escape para fechar o modal com a tecla Esc.
  Este evento é colocado no container mais externo para capturar o evento globalmente quando o modal está visível.
-->
<div (keydown.escape)="closeComun()">

  <div class="modal-backdrop" *ngIf="isComunOpen" (click)="closeComun()"></div>

  <!--
    Melhoria: Adicionado aria-describedby para acessibilidade.
    Ele aponta para o ID do parágrafo principal, ajudando leitores de tela.
  -->
  <div class="modal" *ngIf="isComunOpen" role="dialog" aria-modal="true" aria-labelledby="comunTitle"
    aria-describedby="comunDesc">
    <div class="modal__content" (click)="$event.stopPropagation()">

      <h2 class="title" id="comunTitle">Um Toque Sobre o Traje</h2>

      <div id="comunDesc">
        <p>Para florirmos juntos neste dia especial, gostaríamos de criar um lindo jardim de cerejeiras com a ajuda de
          vocês!</p>

        <p><strong>Nossa sugestão de cores são:</strong></p>
        <!-- Melhoria UI: Usar uma lista torna a informação mais fácil de escanear. -->
        <ul class="color-list">
          <li>Tons Terrosos</li>
          <li>Rosa</li>
          <li>Verde</li>
        </ul>

        <p>Para que nossa flor principal, a aniversariante Laura, tenha seu brilho único, pedimos com carinho que a cor
          <!-- Melhoria de Código: Usando uma classe em vez de estilo inline. -->
          <strong class="text-highlight-red">VERMELHA</strong>
          seja reservada para ela.
        </p>
      </div>

      <div class="modal__actions">
        <!-- Melhoria UX: Microcopy do botão mais amigável. -->
        <button type="button" class="btn btn--primary" (click)="closeComun()">Entendi!</button>
      </div>
    </div>
  </div>
</div>
